
import { Link } from 'react-router-dom';
import NavBar from '../../components/feature/NavBar';
import Industries from '../home/components/Industries';
import SEOHead from '../../components/feature/SEOHead';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://zjfitservices.com';

const industriesJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Industries Served | ZJF IT Services LLC New York',
    description: 'ZJF IT Services LLC delivers reliable IT field services across finance, healthcare, legal, retail, education, and more — serving MSPs and enterprises across New York and nationwide.',
    url: `${siteUrl}/industries`,
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
        { '@type': 'ListItem', position: 2, name: 'Industries', item: `${siteUrl}/industries` },
      ],
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: 'Industries Served by ZJF IT Services LLC',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Financial Services' },
      { '@type': 'ListItem', position: 2, name: 'Healthcare' },
      { '@type': 'ListItem', position: 3, name: 'Legal' },
      { '@type': 'ListItem', position: 4, name: 'Retail & Hospitality' },
      { '@type': 'ListItem', position: 5, name: 'Education' },
      { '@type': 'ListItem', position: 6, name: 'Government & Public Sector' },
      { '@type': 'ListItem', position: 7, name: 'Managed Service Providers (MSPs)' },
    ],
  },
];

export default function IndustriesPage() {
  return (
    <div className="min-h-screen bg-zinc-950">
      <SEOHead
        title="Industries Served | ZJF IT Services LLC New York"
        description="ZJF IT Services LLC delivers reliable IT field services across finance, healthcare, legal, retail, education, and more — serving MSPs and enterprises across New York and nationwide."
        keywords="IT services industries New York, MSP field services, healthcare IT deployment, finance IT support, enterprise IT rollouts NYC"
        canonical={`${siteUrl}/industries`}
        jsonLd={industriesJsonLd}
      />
      <NavBar />
      <div className="pt-20">
        <div className="py-16 bg-zinc-950 text-center border-b border-zinc-800">
          <span className="text-orange-500 text-sm font-semibold uppercase tracking-widest mb-3 block">Who We Serve</span>
          <h1 className="text-5xl font-bold text-white mb-4">Industries Served</h1>
          <p className="text-zinc-400 text-lg max-w-2xl mx-auto">
            From MSPs to enterprise corporations — we deliver reliable IT field services across every sector.
          </p>
        </div>
        <Industries />
        <div className="py-16 bg-zinc-950 text-center">
          <Link
            to="/contact"
            className="bg-orange-500 hover:bg-orange-600 text-white px-10 py-4 rounded-md text-base font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer inline-block"
          >
            Request a Consultation
          </Link>
        </div>
      </div>
    </div>
  );
}
